import React from 'react';

// Набір іконок застосунку: контурні, 24×24, колір — від тексту (currentColor).
// Нова іконка — новий рядок тут, а не SVG, вставлений посеред сторінки.
const PATHS = {
    overview: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
    dynamics: 'M3 17l6-6 4 4 8-8M15 7h6v6',
    compare: 'M7 7h13l-4-4M17 17H4l4 4',
    catalog: 'M3 7l9-4 9 4v10l-9 4-9-4zM3 7l9 4 9-4M12 11v10',
    competitors: 'M4 10v10h16V10M3 10l2-6h14l2 6zM9 20v-6h6v6',
    mapping: 'M10 14a4 4 0 0 0 5.66 0l3-3a4 4 0 0 0-5.66-5.66l-1 1M14 10a4 4 0 0 0-5.66 0l-3 3a4 4 0 0 0 5.66 5.66l1-1',
    parser: 'M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7',
    admin: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z',
    search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM21 21l-5-5',
    logout: 'M9 21H5V3h4M16 17l5-5-5-5M21 12H9',
    sun: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
    moon: 'M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z',
    upload: 'M12 15V3M7 8l5-5 5 5M4 21h16',
    download: 'M12 3v12M7 10l5 5 5-5M4 21h16',
    close: 'M6 6l12 12M18 6L6 18',
    check: 'M5 12l5 5 9-10',
    alert: 'M12 8v5M12 16.5v.5M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z',
    chevronDown: 'M6 9l6 6 6-6',
    chevronLeft: 'M15 6l-6 6 6 6',
    chevronRight: 'M9 6l6 6-6 6',
    arrowLeft: 'M19 12H5M11 6l-6 6 6 6',
    arrowRight: 'M5 12h14M13 6l6 6-6 6',
    arrowDown: 'M12 5v14M6 13l6 6 6-6',
    arrowUp: 'M12 19V5M6 11l6-6 6 6',
    plus: 'M12 5v14M5 12h14',
    menu: 'M4 6h16M4 12h16M4 18h16',
    external: 'M14 4h6v6M20 4l-9 9M18 14v6H4V6h6',
    history: 'M3 12a9 9 0 1 0 3-6.7M3 4v5h5M12 7v5l3 3',
    bolt: 'M13 2L4 14h7l-1 8 9-12h-7z',
    sort: 'M8 4v16M4 8l4-4 4 4M16 20V4M20 16l-4 4-4-4',
};

const Icon = ({ name, size = 20, stroke = 1.8, className, style, title }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        style={style}
        aria-hidden={title ? undefined : true}
        role={title ? 'img' : undefined}
        aria-label={title}
    >
        <path d={PATHS[name]} />
    </svg>
);

// Логотип: стилізована шина.
export const LogoMark = ({ size = 40 }) => (
    <span style={{
        width: size, height: size, borderRadius: size * 0.3, background: 'var(--accent)',
        color: 'var(--on-accent)', display: 'inline-flex', alignItems: 'center',
        justifyContent: 'center', flex: 'none',
    }}>
        <svg width={size * 0.6} height={size * 0.6} viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" aria-hidden="true">
            <circle cx="12" cy="12" r="8.5" />
            <circle cx="12" cy="12" r="3" />
            <path d="M12 3.5V9M12 15v5.5M3.5 12H9M15 12h5.5" />
        </svg>
    </span>
);

export default Icon;
